module.exports = __webpack_public_path__ + "img/selgemlogo.56c317e8.png";